<template>
  <v-form v-model="filterSetValid" ref="filterSetForm">
    <v-row v-for="(filter, key, index) in filters" :key="filter._id">
      <v-col class="flex-grow-0">
        <h5>Include</h5>
        <v-chip-group v-model="filter.type" :rules="[rules.nonEmpty(filter.type, 'operation')]"
                      active-class="primary--text">
          <v-chip small filter v-for="(operation, key) in operations" :key="key" :value="operation.field">
            {{operation.display}}
          </v-chip>
        </v-chip-group>
        <!--        <v-select class="pl-0" :items="operations" item-text="display" item-value="field" label="Operation"-->
        <!--                  v-model="filter.type" :rules="[rules.nonEmpty(filter.type, 'operation')]"-->
        <!--        ></v-select>-->
      </v-col>
      <v-col sm="10" md="3" cols="9">
        <v-select :menu-props="{'contentClass': 'show-scroll'}" :items="fields" item-text="display" item-value="field" label="Field to search" required
                  :rules="[rules.nonEmpty(filter.field, 'field')]"
                  v-model="filter.field" @change="assignValue(filter)"></v-select>
      </v-col>
      <v-col sm="10" md="3" cols="9">
        <v-range-slider
          class="mt-4"
          label="Years"
          v-if="filter.field && filter.field.indexOf('edges') > -1"
          v-model="filter.value"
          min="0"
          max="20"
          thumb-label
          :step="0.5"></v-range-slider>
        <v-text-field
          v-else
          label="Field to search"
          v-model="filter.value"
          @keyup.enter.native="enterPressed"
          required
          :rules="[rules.nonEmpty(filter.value, 'value')]"
          :hint='`You can use "|" to perform "OR" queries`'
          :persistent-hint="true"></v-text-field>
      </v-col>
      <v-col sm="2" md="1" cols="3" class="px-0">
        <v-tooltip>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-action class="mx-2 mt-5">
              <v-icon color="success" @click="addFilterItem()">mdi-plus</v-icon>
            </v-list-item-action>
          </template>
          <span>Add another filter</span>
        </v-tooltip>

        <v-tooltip>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-action class="ml-2 mt-5" v-if="filters.length > 1">
              <v-icon color="error" @click="removeFilterItem(key)">mdi-minus</v-icon>
            </v-list-item-action>
          </template>
          <span>Delete this filter</span>

        </v-tooltip>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import {operations} from "../../constants/constants";
  import {nonEmptyField} from "../../helpers/helpers";

  export default {
    name: "searchFiltersGroup",
    props: ['fields'],
    data: () => ({
      filters: [],
      initialFilters: [
        {type: '$and', field: 'scrapedProfile.full_text', value: null},
      ],
      filterSetValid: false,
      operations: operations,
      rules: {
        nonEmpty: nonEmptyField
      },
    }),
    mounted() {
      //this.search();
      // this.loadAvailableFilters();
      this.filters = this.initialFilters;
    },
    methods: {
      addFilterItem() {
        this.filters.push({type: '$and', field: '', value: null})
      },
      removeFilterItem(index) {
        this.filters = this.filters.filter((e, k) => k !== index);
      },
      enterPressed() {
        this.$emit('enter-pressed', this.filters);
      },
      assignValue(filterElem) {
        filterElem.value = (filterElem.field.indexOf('edges') > -1) ? [0, 20] : null
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Filters/searchFiltersGroup.vue